export enum OrganizationActionTypes {
  GET_ORGANIZATIONS_PENDING = '@@organization/GET_ORGANIZATIONS_PENDING',
  GET_ORGANIZATIONS_SUCCESS = '@@organization/GET_ORGANIZATIONS_SUCCESS',
  GET_ORGANIZATIONS_ERROR = '@@organization/GET_ORGANIZATIONS_ERROR'
}
